import { validOgrn, validBik, validOgrnip, validCadastralNumber, validIndividualInn, validLegalInn, validSnils, minLength } from '@vtblife/validators';
var ERROR_MESSAGES = {
  seriesNumber: 'Поле должно содержать 10 цифр',
  unitCode: 'Поле должно содержать 6 цифр'
};
var documentValidators = {
  ogrn: validOgrn(),
  'ogrn-ip': validOgrnip(),
  cadastr: validCadastralNumber({}),
  inn: validIndividualInn(),
  'inn-ul': validLegalInn(),
  bik: validBik(),
  snils: validSnils(),
  'russian-passport-series-number': minLength({
    limit: 10,
    message: ERROR_MESSAGES.seriesNumber
  }),
  'russian-passport-unit-code': minLength({
    limit: 6,
    message: ERROR_MESSAGES.unitCode
  })
};
export var getValidator = function getValidator(_ref) {
  var template = _ref.template;
  return documentValidators[template];
};